import { createContext } from "react";
import {
  ReactSdkContext,
  useFlags,
  useLDClient,
  withLDProvider,
} from "launchdarkly-react-client-sdk";
import { isBrowser } from "@wisr/common";
import { LDFlagSet } from "launchdarkly-js-client-sdk";
import { FEATUREFLAG_KEY } from "../flag.consts";
import { getConfig } from "../config.utils";
import { getLdUser } from "../../auth/auth.utils";

const { APP_FORM_LAUNCHDARKLY_CLIENTID } = getConfig();

// Inlined from the LD SDK to avoid depending on an undocumented export (reactSdkContextFactory)
const reactSdkContextFactory = () =>
  createContext<ReactSdkContext>({
    flags: {},
    flagKeyMap: {},
    ldClient: undefined,
  });

export const LendingContext = reactSdkContextFactory();
export const AttractContext = reactSdkContextFactory();

export const useLendingFlags = <T extends LDFlagSet = LDFlagSet>(): T =>
  useFlags<T>(LendingContext);

export const useAttractFlags = <T extends LDFlagSet = LDFlagSet>(): T =>
  useFlags<T>(AttractContext);

export const useLendingClient = () => useLDClient(LendingContext);

export const useAttractClient = () => useLDClient(AttractContext);

const ldUser = isBrowser() ? getLdUser() : undefined;

export const withLendingFlags = withLDProvider({
  clientSideID: APP_FORM_LAUNCHDARKLY_CLIENTID || "",
  user: ldUser,
  reactOptions: { reactContext: LendingContext },
});

export const withAttractFlags = withLDProvider({
  clientSideID: FEATUREFLAG_KEY,
  user: ldUser,
  reactOptions: { reactContext: AttractContext },
});
